import { Box, Text } from "@chakra-ui/react";

const TONES = {
  info:    { bg: "dashboard.metric.info.bg" },
  success: { bg: "dashboard.metric.success.bg" },
  warning: { bg: "dashboard.metric.warning.bg" },
  danger:  { bg: "dashboard.metric.danger.bg" },
};

const StatCard = ({ title, data, icon: Icon, tone = "info", bg, prefix = "", postfix = "", sub, ...props }) => {
  const resolvedBg = bg ?? (TONES[tone] ?? TONES.info).bg;

  return (
    <Box
      bg={resolvedBg}
      borderRadius="soft"
      px="22px"
      py="20px"
      display="flex"
      alignItems="flex-start"
      gap="14px"
      boxShadow="cardLift"
      {...props}
    >
      {Icon && (
        <Box
          w="44px"
          h="44px"
          borderRadius="14px"
          bg="rgba(255,255,255,0.2)"
          display="flex"
          alignItems="center"
          justifyContent="center"
          flexShrink={0}
        >
          <Icon size="22px" color="white" />
        </Box>
      )}
      <Box flex={1}>
        <Text fontSize="12px" color="rgba(255,255,255,0.75)" fontWeight="600" mb="4px">
          {title}
        </Text>
        <Text fontFamily="display" fontSize="32px" fontWeight="700" color="white" lineHeight="1">
          {prefix}{data}{postfix}
        </Text>
        {sub && (
          <Text fontSize="12px" color="rgba(255,255,255,0.65)" mt="4px">
            {sub}
          </Text>
        )}
      </Box>
    </Box>
  );
};

export default StatCard;
